export default __webpack_public_path__ + "static/media/Energetic Band.88fa234c.jpg";